import React, { createContext, useContext } from "react";

const AvaliacaoContext = createContext();

export const AvaliacaoProvider = ({ children }) => {

  // Buscar avaliações de um restaurante
  const buscarAvaliacoes = async (restauranteId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/avaliacoes/${restauranteId}?page=0&size=20`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        return await response.json();
      } else {
        throw new Error(`Erro ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Erro ao buscar avaliações:", error);
      throw error;
    }
  };

  const buscarAvaliacoesPaginadas = async (restauranteId, page = 0, size = 10) => {
    console.log('buscando avaliações paginadas...')
    // A lista de comentários é privada (só para quem está logado); sem login devolve null
    // em vez de quebrar a tela (antes o erro impedia até as médias públicas de carregarem).
    const access_token = JSON.parse(sessionStorage.getItem("user") || "{}").access_token;
    if (!access_token) return null;
    // fetch não tem "params": a página e o tamanho precisam ir na URL (antes vinha sempre a primeira página).
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/avaliacoes/restaurante/${restauranteId}?page=${page}&size=${size}`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authentication": access_token
        },
    });

    if (response.ok) {
      return await response.json();
    } else {
      throw new Error(`Erro ${response.status}: ${response.statusText}`);
    }
  };

  // Buscar uma avaliação específica por ID
  const buscarAvaliacaoPorId = async (avaliacaoId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/public/avaliacoes/${avaliacaoId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        return await response.json();
      } else {
        throw new Error(`Erro ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Erro ao buscar avaliação:", error);
      throw error;
    }
  };

  // Buscar média de avaliações de um restaurante
  const buscarMediaAvaliacoes = async (restauranteId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/public/avaliacoes/media/restaurante/${restauranteId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        return await response.json();
      } else {
        throw new Error(`Erro ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Erro ao buscar média de avaliações:", error);
      throw error;
    }
  };

  // Salvar nova avaliação
  const salvarAvaliacao = async (novaAvaliacao, restauranteId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/public/avaliacoes`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(novaAvaliacao),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `Erro ${response.status}: ${response.statusText}`
        );
      }
      
      return await response.json();
    } catch (error) {
      console.error("Erro ao salvar avaliação:", error);
      throw error;
    }
  };

  // Atualizar avaliação existente
  const atualizarAvaliacao = async (avaliacaoId, avaliacaoAtualizada) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/avaliacoes/${avaliacaoId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(avaliacaoAtualizada),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `Erro ${response.status}: ${response.statusText}`
        );
      }
      
      return await response.json();
    } catch (error) {
      console.error("Erro ao atualizar avaliação:", error);
      throw error;
    }
  };

  // Deletar avaliação
  const deletarAvaliacao = async (avaliacaoId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/avaliacoes/${avaliacaoId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `Erro ${response.status}: ${response.statusText}`
        );
      }
      
      return true;
    } catch (error) {
      console.error("Erro ao deletar avaliação:", error);
      throw error;
    }
  };

  return (
    <AvaliacaoContext.Provider
      value={{
        buscarAvaliacoes,
        buscarAvaliacaoPorId,
        buscarMediaAvaliacoes,
        salvarAvaliacao,
        atualizarAvaliacao,
        deletarAvaliacao,
        buscarAvaliacoesPaginadas
      }}
    >
      {children}
    </AvaliacaoContext.Provider>
  );
};

export const useAvaliacao = () => useContext(AvaliacaoContext);